module.exports = __webpack_public_path__ + "static/img/Brodie-Grundy.a9feab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brodie-Grundy.jpg
// module id = TrKd
// module chunks = 0